import React from "react";
import { InputRightIcon } from "modules/common/components/form/Common";
import { PlanrInput } from "./Input";

/**
 * Поле поиска: круглое поле planr, справа лупа, а когда что-то введено —
 * крестик очистки на её месте. Тот же вид, что у `form/Search.tsx`
 * над списками, только без зашитого `marginLeft: 16px` — отступ задаёт
 * раскладка (`Stack`), а не само поле.
 *
 * ```tsx
 * <PlanrSearch query={query} onSearch={setQuery} placeholder="Поиск сотрудника" />
 * ```
 */
export const PlanrSearch = ({ query, onSearch, placeholder = "Поиск", disabled, className, style }: PlanrSearchProps) => (
    <PlanrInput
        variant="round"
        className={className}
        style={style}
        disabled={disabled}
        placeholder={placeholder}
        value={query}
        onChange={(e) => onSearch(e.target.value)}
        rightElement={InputRightIcon({
            hasValue: !!query,
            disabled,
            onClear: () => onSearch(""),
            icon: "search",
        })}
    />
);

export interface PlanrSearchProps {
    query: string;
    onSearch: (query: string) => void;
    placeholder?: string;
    disabled?: boolean;
    className?: string;
    style?: React.CSSProperties;
}
